export enum TimeFormatType {
  Format24h = '24h',
  Format12h = '12h',
}
